import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import useAuth from '../../pages/useAuth';
import AttendanceCard from '../../components/AttendanceCards';

const USER_Dashboard = () => {
     useAuth();
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [attendanceData, setAttendanceData] = useState(null);

     useEffect(() => {
          const fetchAttendance = async () => {
               try {
                    const response = await fetch(`${baseUrl}/getUserAttendance`, {
                         method: "GET",
                         headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${sessionStorage.getItem("token")}`
                         },
                    });

                    const data = await response.json();
                    if (data.status) {
                         setAttendanceData(data.data);
                    }
               } catch (error) {
                    console.error("Error fetching attendance:", error);
               }
          };

          fetchAttendance();
     }, [baseUrl]);

     const todayPunchIn = attendanceData?.today?.punch_in || "-";
     const todayPunchOut = attendanceData?.today?.punch_out || "-";

     return (
          <div style={{ padding: 24, backgroundColor: '#f7f9fc', minHeight: '100vh' }}>
               <div style={{ maxWidth: 1000, margin: '0 auto' }}>
                    {/* <h4 style={{ marginBottom: 12 }}>User Dashboard</h4> */}

                    <Row style={{ marginBottom: 16 }}>
                         <Col md={6}>
                              <AttendanceCard
                                   title="Today's Attendance"
                                   present={todayPunchIn}
                                   absent={todayPunchOut}
                              />
                         </Col>
                         <Col md={6}>
                              {/* <Card>
                                   <Card.Body>
                                        <h5 style={{ marginBottom: 8 }}>My Summary</h5>
                                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                             <div>
                                                  <div style={{ fontSize: 13, color: '#666' }}>Leaves Remaining</div>
                                                  <div style={{ fontSize: 18, fontWeight: 700 }}>—</div>
                                             </div>
                                             <div>
                                                  <div style={{ fontSize: 13, color: '#666' }}>Upcoming Holidays</div>
                                                  <div style={{ fontSize: 18, fontWeight: 700 }}>—</div>
                                             </div>
                                        </div>
                                   </Card.Body>
                              </Card> */}
                         </Col>
                    </Row>

                    <Card>
                         <Card.Body style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                              <Button size="sm" onClick={() => (window.location.href = '#')}>Notifications</Button>
                              <Button size="sm" onClick={() => (window.location.href = '#')}>My Tasks</Button>
                              <Button size="sm" onClick={() => (window.location.href = '#')}>My Leaves</Button>
                              <Button size="sm" onClick={() => (window.location.href = '/profile')}>Profile</Button>
                         </Card.Body>
                    </Card>
               </div>
          </div>
     );
};

export default USER_Dashboard;